interface GroupableCall {
  id: string;
  customerId: string | null;
  callerPhoneNumber: string;
  callerDisplayName: string;
  startedAt: string;
  summary: string;
}

export interface CallGroup<C extends GroupableCall> {
  key: string;
  displayName: string;
  phoneNumber: string;
  calls: C[];
  latestCall: C;
}

export function groupCallsByPerson<C extends GroupableCall>(
  calls: C[],
): Array<CallGroup<C>> {
  const groups = new Map<string, C[]>();
  for (const call of calls) {
    const key = call.customerId
      ? `customer:${call.customerId}`
      : `phone:${normalizePhone(call.callerPhoneNumber)}`;
    const existing = groups.get(key);
    if (existing) existing.push(call);
    else groups.set(key, [call]);
  }

  return [...groups.entries()]
    .map(([key, entries]) => {
      const sorted = [...entries].sort((left, right) =>
        right.startedAt.localeCompare(left.startedAt),
      );
      const latestCall = sorted[0]!;
      return {
        key,
        displayName: latestCall.callerDisplayName,
        phoneNumber: latestCall.callerPhoneNumber,
        calls: sorted,
        latestCall,
      };
    })
    .sort((left, right) =>
      right.latestCall.startedAt.localeCompare(left.latestCall.startedAt),
    );
}

function normalizePhone(value: string) {
  return value.replace(/[^\d+]/g, "");
}
